import React from 'react';
import { Grid } from '@material-ui/core';
import { FaChevronCircleRight } from 'react-icons/fa';

import { useWindowSize } from '../../../hooks/windowSize';

import { useStyles } from './styles';

interface IRightBar {
  onCloseRightBar?: () => void;
}

const RightBar: React.FC<IRightBar> = ({ onCloseRightBar, children }) => {
  const classes = useStyles();
  const size = useWindowSize();

  return (
    <Grid
      item
      md={4}
      lg={3}
      xl={2}
      className={classes.container}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: size.height ? size.height - 152 : '100%',
      }}
    >
      <div className={classes.content}>
        <button
          type="button"
          onClick={onCloseRightBar}
          className={classes.floatingButton}
        >
          <FaChevronCircleRight size={24} color="#7030A0" />
        </button>
        {children}
      </div>
    </Grid>
  );
};

export default RightBar;
